import * as types from './actionTypes';
import { departmentService } from '../_services';

export function fetchDepartmentList() {
  return dispatch => {
    return departmentService
      .getAllDepartments()
      .then(payload => {
        dispatch(success(payload));
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function success(payload) {
    return { type: types.FETCH_DEPARTMENTSLIST, payload: payload };
  }
  function failure(error) {
    return { type: types.FETCH_DEPARTMENTSLIST_FAILURE, error };
  }
}
